import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'


import styles from './styles.module.scss'
import { ParticipantProps, SidebarParticipant } from './types'
import { useParticipants } from './useParticipants'
import { ParticipantItem } from '../ParticipantItem/ParticipantItem'

export const Participants = ({
  conversation,
  onParticipantSelect,
}: ParticipantProps) => {
  const { t } = useTranslation()

  const handleOpenDetails = useCallback(
    (participant: SidebarParticipant) => {
      onParticipantSelect?.(participant)
    },
    [onParticipantSelect]
  )

  const participants = useParticipants(conversation)
  const currentUserParticipant = participants.find((p) => p.isCurrentUser)
  const isCurrentUserPrivateAdvertiser = Boolean(
    currentUserParticipant?.isPrivateAdvertiser
  )

  return (
    <>
      <div className={styles.title}>{t('Chat.Sidebar.Participants.Title')}</div>
      <div className={styles.participantsContainer}>
        {participants.map((p) => (
          <ParticipantItem
            key={p.id}
            participantItem={p}
            onClick={handleOpenDetails}
            isCurrentUserPrivateAdvertiser={isCurrentUserPrivateAdvertiser}
          />
        ))}
        <div className={styles.separator}></div>
      </div>
    </>
  )
}
